import { Box, Typography, Checkbox, Stack, Tooltip } from '@mui/material'
import ColoredMultySelect, {
  TValues,
} from 'components/ui/ColoredMultySelect/ColoredMultySelect'
import { FILTERS_MODE } from '../DataAnalysisFilters'
import { useCallback, useMemo } from 'react'
import {
  filtersCounterTextStyle,
  filtersHeaderStyle,
} from '../../DataAnalysisFiltersInfo.styled'

interface WheatCodeFilterProps {
  wheatCodes: any[]
  wheatCodeColorMap: Record<number, string>
  selectedCodes: string[]
  onCodesChange: (codes: string[]) => void
}

export const WheatCodeFilter = ({
  wheatCodes,
  wheatCodeColorMap,
  selectedCodes,
  onCodesChange,
}: WheatCodeFilterProps) => {
  const options: TValues[] = wheatCodes.map((w: any) => ({
    id: Number(w.id),
    name: String(w.code),
    color: wheatCodeColorMap[w.id],
    checked: selectedCodes.includes(String(w.code)),
  }))

  const allSelected = useMemo(() => {
    return wheatCodes.length > 0 && selectedCodes.length === wheatCodes.length
  }, [wheatCodes.length, selectedCodes.length])

  const handleSelectAll = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        const allCodes = wheatCodes.map((w: any) => String(w.code))
        onCodesChange(allCodes)
      } else {
        onCodesChange([])
      }
    },
    [wheatCodes, onCodesChange]
  )

  return (
    <Box>
      <Stack sx={filtersHeaderStyle}>
        <Tooltip title={allSelected ? 'Deselect all' : 'Select all'}>
          <Checkbox
            checked={allSelected}
            onChange={handleSelectAll}
            size="small"
          />
        </Tooltip>
        <Typography>
          Wheat Codes
          {selectedCodes.length ? (
            <Typography component="span" sx={filtersCounterTextStyle}>
              ({selectedCodes.length})
            </Typography>
          ) : (
            ''
          )}
        </Typography>
      </Stack>
      <ColoredMultySelect
        valuesList={options}
        isSquare={false}
        mode={FILTERS_MODE.LIST}
        handleListChange={onCodesChange}
      />
    </Box>
  )
}
